import { SET_LAYOUT_MODE } from '../../../constants/layoutMode';

export const setLayoutMode = (payload: boolean) => ({
  type: SET_LAYOUT_MODE,
  payload,
});
